<mat-checkbox
  (change)="_changed($event.checked)"
  [matTooltip]="tooltip"
  [disabled]="!hasPermission"
  [checked]="element ? element[selectionAttribute] : false"
>
</mat-checkbox>
